export default __webpack_public_path__ + "static/media/jablonski.5520b326.jpg";